import {copyElement, getNewCount, openInNewTab} from '@/libs/helper'
import {isEmpty} from 'lodash'
export default {
    name: 'DetailMenu',
    props: {
        isCollection: {
            type: Boolean,
            default: false
        },
        isDossier: {
            type: Boolean,
            default: () => {}
        },
        module: {
            type: String,
            default: ''
        },
        details: {
            type: Object,
            default: () => {}
        },
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        followUnfollowAction: {
            type: Function,
            default: () => {}
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        followCollection: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        setFavourite: {
            type: Function,
            default: () => {}
        },
        articlesCount: {
            type: Number,
            default: 0
        },
        collectionCount: {
            type: Number,
            default: 0
        },
        followersCount: {
            type: Number,
            default: 0
        },
        collectionFollowersCount: {
            type: Number,
            default: 0
        },
        dossierCount: {
            type: Number,
            default: 0
        },
        collectionArticleCount: {
            type: Number,
            default: 0
        },
        routeToCollectionPage: {
            type: Function,
            default: () => {}
        },
        setCollectionFavorite: {
            type: Function,
            default: () => {}
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        routeToAboutPage: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            openInNewTab,
            copyElement,
            isEmpty,
            getNewCount,
            settingsDropdown: false
        }
    },
    methods: {
        /*
         * returns the user to fetch the user's avatar.
         * */
        getURL(imageName){
            return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${imageName}?auth=${localStorage.getItem('accuraAuthToken')}`
        },
        /*
         * return the place holder image in case of error in image loading.
         * */
        onError(e) {
            let avatarURL = require('@/assets/images/author_placeholder.png');
            if (e.target.src !== avatarURL) {
                e.target.src = avatarURL;
            }
        }
    },
}